import React from 'react'
import classNames from 'classnames'
import { ConsultingConditions, ConsultingHeader } from '../FinancingConsultingFormStep/components'
import './styles.scss'

interface FinancingConsultingWrapperProps {
  onHeaderClick?: () => void
  children: React.ReactNode
  isFollowingStep?: boolean
}

export const FinancingConsultingWrapper = ({ onHeaderClick, children, isFollowingStep }: FinancingConsultingWrapperProps) => {
  return (
    <div className="financingConsultingWrapper elevatableBlock">
      <div
        className={classNames('financingConsultingWrapper__info', {
          'financingConsultingWrapper__info--followingStep': isFollowingStep,
        })}
      >
        <ConsultingHeader onClick={onHeaderClick} />
        <ConsultingConditions />
      </div>
      <div className="financingConsultingWrapper__form">{children}</div>
    </div>
  )
}
